module.exports = __webpack_public_path__ + "img/event_pc_tab_03.5819ca23.png";